
<div mat-dialog-title class="mat-dialog-title" id="modalAddressTitle">
  <h3 class="nsc-title" >Address Notification</h3>
  <button mat-dialog-close class="close" type="button" aria-label="Close confirmation dialog">
    <mat-icon class="nsc-icon__svg" svgIcon="close" aria-hidden="true"></mat-icon>
  </button>
</div>
<mat-dialog-content id="modalAddressContent" class="mat-typography">
  <p class= "">{{addressValidationMessage}}</p>
  <p class="">{{instructionalText}}</p>
  @if (addressCorrected) {
    <div class="row justify-content-center">
      @if (show.suggestedAddress) {
        <div class="col-auto nsc-wrapper-option">
          <p class="subTitle">
            <strong>Suggested Address</strong>
          </p>
          <button id="address_validation_SuggestedAddress"  color="primary"  mat-stroked-button   type="button" (click)="dialogRef.close(correctedAddressValues)">
            {{ correctedAddressValues.delivery_line_1 || correctedAddressValues.address1}}
            @if ((correctedAddressValues.delivery_line_2 || correctedAddressValues.address2)) {
              <br>
              }
              {{correctedAddressValues.delivery_line_2 || correctedAddressValues.address2 }}
              <br>
                {{correctedAddressValues.components.city_name || correctedAddressValues.components.locality }}@if ((correctedAddressValues.components.city_name || correctedAddressValues.components.locality)) {
                <span>,</span>
                } {{correctedAddressValues.components.state_abbreviation || correctedAddressValues.components.administrative_area}}
                <br>
                  {{postalOrZipCode}}
                </button>
              </div>
            }
            @if (show.suggestedAddress && continueOnlyWithValidAddress) {
              <div class="col-auto">
                <strong>Entered Address</strong><br>
                <p >
                  {{enteredAddress.request.street}} @if (!isNullorBlank(enteredAddress.request.street2)) {
                  <br>
                  }
                  {{enteredAddress.request.street2}} <br>
                  {{enteredAddress.request.city}} @if (enteredAddress.request.state !='ZZ') {
                  <span>{{enteredAddress.request.state}}</span>
                } {{enteredAddress.request.zipcode}}</p>
              </div>
            }
            <!-- <nsc-spacer size="sm"></nsc-spacer> -->
            @if (show.suggestedAddress && show.enteredAddress) {
              <div class="col-auto nsc-wrapper-option">
                <p class="subTitle">
                  <strong>Entered Address</strong>
                </p>
                <button  id="address_validation_EnteredAddress" color="primary" mat-stroked-button type="button"   (click)="dialogRef.close(enteredAddress)">
                  {{enteredAddress.request.street}} @if (!isNullorBlank(enteredAddress.request.street2)) {
                  <br>
                  }
                  {{enteredAddress.request.street2}} <br>
                  {{enteredAddress.request.city}} @if (enteredAddress.request.state !='ZZ') {
                  <span>{{enteredAddress.request.state}}</span>
                  } {{enteredAddress.request.zipcode}}
                </button>
              </div>
            }
          </div>
        }
        @if (!addressCorrected && show.enteredAddress && !missingSecondary) {
          <div>
            <nsc-spacer size="sm"></nsc-spacer>
            <strong>Entered Address</strong><br>
            <p class="m-sm">
              {{enteredAddress.request.street}} @if (!isNullorBlank(enteredAddress.request.street2)) {
              <br>
              }
              {{enteredAddress.request.street2}} <br>
              {{enteredAddress.request.city}} @if (enteredAddress.request.state !='ZZ') {
              <span>{{enteredAddress.request.state}}</span>
            } {{enteredAddress.request.zipcode}} </p>
          </div>
        }
        @if (missingSecondary) {
          <div>
            <form [formGroup]="formGroup" novalidate>
              <mat-form-field appearance="outline" [formGroup]="group" >
                <input id="address_validation_change_apt" matInput formControlName='secondaryNbr' placeholder="Correct your Apt/Suite Number">
              </mat-form-field>
              <button id="address_validation_submit" [disabled]="!formGroup.secondaryNbr" mat-raised-button color="primary" class="nsc-button " type="button" [mat-dialog-close]='secondaryNbr'
              cdkFocusInitial>Submit</button>
            </form>
          </div>
        }
        <nsc-spacer size="sm"></nsc-spacer>
        @if (show.suggestedAddress && continueOnlyWithValidAddress) {
          <button id="address_validation_change_suggested" color="primary" mat-stroked-button class="nsc-button" type="button"
          (click)="dialogRef.close(false)">Edit Address</button>
        }
        @if (!addressCorrected) {
          <div class="d-flex justify-content-center">
            <button mat-raised-button id="address_validation_EditAddress" class="nsc-button " type="button" color="primary" (click)="dialogRef.close(false)">Edit Address</button>
            <nsc-spacer size="md"></nsc-spacer>
            <button mat-raised-button id="address_validation_use_entered" class="nsc-button " type="button" color="primary" (click)="dialogRef.close(true)">Use Entered Address</button>
          </div>
        }


      </mat-dialog-content>